import {config, http} from './__http';

export default {
    getDownloads(downloads, params) {
        http.get(config.baseUrl()+'/dl', params).then(response => {
            downloads(response.data);
        }).catch(e => {
            downloads(e.response)
        });
    },
    sendDownloads(downloads, params) {
        http.post(config.baseUrl()+'/dl/'+params.type+'?resolution='+params.resolution, params.body).then(response => {
            downloads(response.data);
        }).catch(e => {
            downloads(e.response)
        });
    },
    getProductInfoAsCsv(csv, params) {
        http.post(config.baseUrl()+'/dl/product-info/csv', params).then(response => {
            csv(response.data);
        }).catch(e => {
            csv(e.response)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Download.js